module.exports = {"id":"208509","name":"Thomas Foket","rating":"73","photo":"./data/images/photos/1/208509.png","club":{"name":"KAA La Gantoise","logo":"./data/images/clubs/KAALaGantoise.png"},"positions":["DD","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ThomasFoket0.json
// module id = 4105
// module chunks = 0